import { styled, Theme } from '@mui/material';
import React, { CSSProperties } from 'react';

type OutOfStockPillProps = {
  containerStyle?: CSSProperties;
  pillContainerStyle?: CSSProperties;
  baseFontSize?: number;
};

const StyledContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  columnGap: 7,
  '*': {
    mixBlendMode: 'unset !important',
  },
  '.outOfStock-pill': {
    textWrap: 'nowrap',
    borderRadius: 25,
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: 0,
    display: 'flex',
    alignItems: 'center',
    ':hover': {
      cursor: 'default',
    },
  },
}));

const StyledOutOfStockPill = styled('div')(({ theme }) => ({
  borderRadius: '999px',
  color:
    (theme.vars as unknown as Theme).globalComponentPresets?.pill.outOfStock.contrastText ||
    theme.vars.palette.text.primary,
  backgroundColor: (theme.vars as unknown as Theme).globalComponentPresets?.pill.outOfStock.main,
  display: 'flex',
  width: 'fit-content',
}));

export const OutOfStockPill = ({
  containerStyle: containerStyleOverride = {},
  pillContainerStyle = {},
  baseFontSize = 14,
}: OutOfStockPillProps) => {
  const pillDefaultPadding = {
    paddingTop: baseFontSize / 3, // top slightly larger than bottom to adjust text alignment
    paddingLeft: baseFontSize * 0.95,
    paddingBottom: baseFontSize / 3,
    paddingRight: baseFontSize * 0.95,
  };

  return (
    <StyledContainer
      style={{
        display: 'block',
        width: 'fit-content',
        ...containerStyleOverride,
      }}
    >
      <StyledOutOfStockPill>
        <div
          className="outOfStock-pill"
          style={{
            ...pillDefaultPadding,
            ...pillContainerStyle,
            fontWeight: 600,
          }}
        >
          {'Sold out'}
        </div>
      </StyledOutOfStockPill>
    </StyledContainer>
  );
};
